// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./resources/assets/sass/backend.scss
// module id = 39
// module chunks = 3